import { ReactNode } from 'react';

interface BlurTextProps {
  children: ReactNode;
  className?: string;
}

export function BlurText({ children, className = '' }: BlurTextProps) {
  return (
    <span 
      className={`inline-block select-none ${className}`}
      style={{
        color: 'transparent',
        textShadow: '0 0 6px rgba(148, 163, 184, 0.7)',
      }}
    >
      {children}
    </span>
  );
}

export default BlurText;
